/* eslint-disable react-hooks/exhaustive-deps */
import "./admin-table.css";
import swal from "sweetalert";
import { BsTrash3Fill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  deleteDepartment,
  fetchAllDepartments,
} from "../../redux/apiCalls/departmentApiCalls";


const DepartmentTable = () => {
  const dispatch = useDispatch();

  const departments = useSelector((state) => state.department.departments);
  useEffect(() => {
    dispatch(fetchAllDepartments());
  }, []);

  // Delete department Handler
  const deleteDepartmentHandler = (departmentId) => {
    swal({
      title: "هل فعلا تريد الحذف ؟",
      text: "لن تستطيع استعادة البيانات ثانية.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isOk) => {
      if (isOk) {
        dispatch(deleteDepartment(departmentId));
      }
    });
  };

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <h1 className="table-title">التخصصات</h1>
        <table className="table">
          <thead>
            <tr>
              <th>م</th>
              <th>التخصص</th>
              <th>------</th>
            </tr>
          </thead>
          <tbody>
            {departments?.map((item, index) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                <td>
                  <b className="table-username">{item?.title} </b>
                </td>
                <td>
                  <div className="table-button-group">
                    <button onClick={() => deleteDepartmentHandler(item?._id)}>
                      <BsTrash3Fill />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DepartmentTable;
